module.exports = __webpack_public_path__ + "static/img/celoscope-10.668b9d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-10.jpg
// module id = eT24
// module chunks = 52